import React, { useState, useEffect, useMemo } from 'react';
import apiClient from '../utils/apiClient';
import Swal from 'sweetalert2';
import Select from "react-select";
import { SERVER_BASE } from '../config/server';
import { useLocation, useNavigate } from "react-router-dom";
import { booleanOptions, centerOptions, stateOptions } from './masterList';
const LedgerMaster = () => {
  const [ledgerGroups, setLedgerGroups] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const code = localStorage.getItem('code');
  const role = localStorage.getItem('role')
  const token = localStorage.getItem('token');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const [profileDetails, setProfileDetails] = useState(null);
  const email = localStorage.getItem('email')
  const location = useLocation();
  const { row, readOnly } = location.state || {};

  const navigate = useNavigate(); // Initialize useNavigate
  const [formData, setFormData] = useState({
    selectedGroup: '',
    ledgerGroupCode: '',
    ledgerName: '',
    ledgerCode: '',
    gstin: '',
    address: '',
    pincode: '',
    state: '',
    person1: '',
    position1: '',
    mobile1: '',
    person2: '',
    position2: '',
    mobile2: '',
    centerType: '',
    city: '',
    printName: '',
    stateCode: '',
    areaJurisdiction: '',
    maintainBalance: 'No'
  });

  useEffect(() => {
    fetchLedgerGroups();
    fetchLedgerMasters();
    fetchProfileDetails();
  }, []);
  useEffect(() => {
    if (row) {
      const grp = ledgerGroups.find(grp => grp.value == row.ledgerGroup);
      setFormData({
        selectedGroup: grp || '',
        ledgerGroupCode: row.ledgerGroupCode || '',
        ledgerName: row.ledgerName || '',
        ledgerCode: row.ledgerCode || '',
        gstin: row.gstin || '',
        address: row.address || '',
        pincode: row.pincode || '',
        state: row.state || '',
        person1: row.person1 || '',
        position1: row.position1 || '',
        mobile1: row.mobile1 || '',
        person2: row.person2 || '',
        position2: row.position2 || '',
        mobile2: row.mobile2 || '',
        centerType: row.centerType || '',
        city: row.city || '',
        printName: row.printName || '',
        areaJurisdiction: row.areaJurisdiction || '',
        stateCode: row.stateCode || '',
        maintainBalance: row.maintainBalance || ''
      });
    }
  }, [row, ledgerGroups, stateOptions]); // rerun effect when either row or ledgerGroups change


  useEffect(() => {
    const centerType = formData.centerType?.trim();
    const city = formData.city?.trim();
    const state = formData.state?.trim();
    const Address = formData.address?.trim()
    const parts = [formData.ledgerName];
    if (Address) parts.push(Address)
    if (city) parts.push(city);
    if (state) parts.push(state);
    const printname = parts.join(', ');
    setFormData((prevData) => ({ ...prevData, printName: printname }));
  }, [formData.ledgerName, formData.city, formData.state, formData.address]); // Dependencies

  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);
    }
  };

  const fetchLedgerMasters = async () => {
    try {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage
      if (!token) {
        console.error('Unauthorized: No token found.');
        Swal.fire({
          icon: 'error',
          text: 'You need to log in to fetch ledger masters.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      const response = await apiClient.get(SERVER_BASE + '/ledgerMasters', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setLedgers(response.data); // Set the ledger data fetched from backend
    } catch (error) {
      console.error('Error fetching ledger masters:', error);
    }
  };
  const handleCenterTypeChange = (selectedOption) => {
    const newCenterType = selectedOption ? selectedOption.value : '';

    setFormData(prev => ({
      ...prev,
      centerType: newCenterType,
      areaJurisdiction: ['Center', 'SubCenter', 'Point'].includes(newCenterType)
        ? prev.areaJurisdiction
        : '' // Clear it if the new centerType doesn't require it
    }));
  };



  const fetchLedgerGroups = async () => {
    try {
      // Retrieve token from localStorage
      if (!token) {
        console.error('Unauthorized: No token found.');
        Swal.fire({
          icon: 'error',
          text: 'You need to log in to fetch ledger groups.',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      const response = await apiClient.get(SERVER_BASE + '/ledger-groups', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        params: { code }, // Include code as a query parameter
      });
      const groups = response.data.map((group) => ({
        label: `${group.groupName} - ${group.groupCode}`,
        value: group.groupName,
        ledgerGroupCode: group.groupCode,
      }));
      setLedgerGroups(groups);
    } catch (error) {
      console.error('Error fetching ledger groups:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // const handleSelectChange = (name, value) => {
  //   if (name === "selectedGroup") {
  //     const newFormData = {
  //       ...formData,
  //       selectedGroup: value,
  //       ledgerGroupCode: value?.ledgerGroupCode || "",
  //     };

  //     // Auto-fill the ledger name if the group is RSSB Center
  //     if (value?.value === "RSSB Center") {
  //       newFormData.ledgerName = "Radha Soami Satsang Beas";
  //     }

  //     setFormData(newFormData);
  //   } else {
  //     setFormData((prevData) => ({ ...prevData, [name]: value }));
  //   }
  // };

  const handleSelectChange = (name, value) => {
    if (name === "selectedGroup") {
      setFormData((prevFormData) => {
        const isPreviousRS = prevFormData.selectedGroup?.ledgerGroupCode === 'RS';
        const isNewRSSB = value?.value === "RSSB Center";

        return {
          ...prevFormData,
          selectedGroup: value,
          ledgerGroupCode: value?.ledgerGroupCode || "",
          ledgerName: isNewRSSB ? "Radha Soami Satsang Beas" : prevFormData.ledgerName,
          centerType: isPreviousRS ? '' : prevFormData.centerType,
          areaJurisdiction: isPreviousRS ? '' : prevFormData.areaJurisdiction
        };
      });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  const handleStateChange = (selectedOption) => {

    // Set state if no issues
    setFormData((prev) => ({
      ...prev,
      state: selectedOption.value,
      stateCode: selectedOption.code,
    }));
  };
  const toggleFormVisibility = () => {
    setFormVisible(!formVisible);
    resetForm();
    setEditIndex(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { selectedGroup, ledgerName } = formData;

    // Validation to check if the required fields are filled
    if (ledgerName.trim() === '' || selectedGroup === '') {
      Swal.fire({
        icon: 'warning',
        text: 'Ledger Group and Name is Required',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    // GSTIN validation (only if GSTIN is filled)
    const isValidGSTIN = (gstin) => {
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      return gstinRegex.test(gstin);
    };

    if (formData.gstin && !isValidGSTIN(formData.gstin)) {
      Swal.fire({
        icon: 'error',
        text: 'Invalid GSTIN. Please enter a valid 15-character GSTIN.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (selectedGroup?.ledgerGroupCode == 'RS' && !formData.centerType) {
      Swal.fire({
        icon: 'error',
        text: 'Center Type is Required',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (selectedGroup?.ledgerGroupCode == 'RS' && (formData.centerType != 'MAJOR CENTER' && formData.centerType != 'UNKNOWN') && !formData.areaJurisdiction) {
      Swal.fire({
        icon: 'error',
        text: 'Area Jurisdiction is Required',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    if (!formData.state) {
      Swal.fire({
        icon: 'error',
        text: 'State is required',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (!formData.maintainBalance) {
      Swal.fire({
        icon: 'error',
        text: 'Maintain Balance selection is required.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    const token = localStorage.getItem('token'); // Retrieve token from localStorage
    if (!token) {
      Swal.fire({
        icon: 'error',
        text: 'Unauthorized: Please log in to proceed.',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    // Show confirmation dialog for creation or update
    Swal.fire({
      title: row ? 'Confirm Update' : 'Confirm Create',
      text: row ? 'Are you sure you want to update this ledger?' : 'Are you sure you want to create this ledger?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Prepare data to be saved
          const createdBy = email;
          const createdByBadge = badgeId;
          const ledgerData = { ...formData, code, createdBy, createdByBadge };

          if (row) {
            // Update ledger API call
            const response = await apiClient.put(
              `${SERVER_BASE}/updateLedgerMaster/${row?.id}`,
              ledgerData,
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Include JWT token in the header
                },
              }
            );

            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                text: 'Ledger has been updated successfully!',
                toast: true,
                position: 'top-end',
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then(() => {
                navigate('../ledgerMaster')
              });
            }
          } else {

            const response = await apiClient.post(
              `${SERVER_BASE}/addledgerMaster`,
              ledgerData,
              {
                headers: {
                  Authorization: `Bearer ${token}`, // Include JWT token in the header
                },
              }
            );

            if (response.status === 200) {
              fetchLedgerMasters(); // Refresh ledger list
              Swal.fire({
                icon: 'success',
                text: 'Ledger has been created successfully!',
                toast: true,
                position: 'top-end',
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then(() => {
                navigate('../ledgerMaster')
              });
            }
          }
        } catch (error) {
          console.error('Error saving ledger:', error);
        }
      }
    });
  };


  const resetForm = () => {
    setFormData({
      selectedGroup: '',
      ledgerGroupCode: '',
      ledgerName: '',
      ledgerCode: '',
      gstin: '',
      address: '',
      pincode: '',
      state: '',
      person1: '',
      position1: '',
      mobile1: '',
      person2: '',
      position2: '',
      mobile2: '',
      centerType: '',
      city: '',
      printName: '',
    });
  };
  const handleAreaJurisdictionChange = (selectedOption) => {
    const value = selectedOption ? selectedOption?.value : '';

    setFormData(prev => ({
      ...prev,
      areaJurisdiction: value,
      state: value === 'Yes' ? 'Rajasthan' : '',
      stateCode: value === 'Yes' ? '08' : ''
    }));
  };




  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className='d-flex gap-3'>
          <button
            className="btn btn-success btn-sm"
            onClick={() => { navigate('../ledgerMaster') }}
          >
            Back
          </button>
          <h4>Ledger Master</h4>

        </div>
        <div className="ledger-count">
          Total Ledgers: <strong>{ledgers.length}</strong>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="formcontainer mb-3">
        <div className="row mb-3">
          <div className="col-md-3">
            <label htmlFor="selectedGroup">Ledger Group</label>
            <Select
              options={ledgerGroups}
              value={formData.selectedGroup}
              onChange={(value) => handleSelectChange("selectedGroup", value)}
              isDisabled={readOnly}
            />
          </div>
          {/* <div className="col-md-3">
            <label htmlFor="ledgerCode">Ledger Code</label>
            <input
              type="text"
              id="ledgerCode"
              name="ledgerCode"
              className="form-control"
              value={formData.ledgerCode}
              onChange={handleInputChange}
            />
          </div> */}

          <div className="col-md-3">
            <label htmlFor="ledgerName">Ledger Name</label>
            <input
              type="text"
              id="ledgerName"
              name="ledgerName"
              className="form-control"
              value={formData.ledgerName}
              onChange={handleInputChange}
              readOnly={formData?.selectedGroup?.ledgerGroupCode == 'RS' || readOnly}
              required
            />
          </div>
          {formData.selectedGroup?.ledgerGroupCode == 'RS' && <>
            <div className="col-md-3">
              <label htmlFor="centerType">Center/Point/HO/Branch</label>
              <Select
                id="centerType"
                name="centerType"
                options={centerOptions}
                value={centerOptions.find(option => option.value == formData.centerType) || null}
                onChange={handleCenterTypeChange}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Type"
                isDisabled={readOnly}
              />
            </div>
          </>}
          {['CENTER', 'SUB CENTER', 'POINT'].includes(formData.centerType) && (
            <div className="col-md-3">
              <label htmlFor="areaJurisdiction">Under Area Jurisdiction</label>
              <Select
                id="areaJurisdiction"
                name="areaJurisdiction"
                options={booleanOptions}
                value={booleanOptions.find(option => option.value == formData.areaJurisdiction) || null}
                onChange={handleAreaJurisdictionChange}
                placeholder="Select Yes or No"
                isDisabled={readOnly}
              />
            </div>
          )}

          <div className="col-md-3">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              className="form-control"
              value={formData.address}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="city">City/District/Village</label>
            <input
              type="text"
              id="city"
              name="city"
              className="form-control"
              value={formData.city}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>

          <div className="col-md-3">
            <label className="">State</label>
            <Select
              name="state"
              options={stateOptions}
              value={stateOptions.find((option) => option.value == formData.state)}
              onChange={handleStateChange}
              placeholder="Select State"
              isDisabled={formData.areaJurisdiction == 'Yes' || readOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="pincode">Pincode</label>
            <input
              type="text"
              id="pincode"
              name="pincode"
              className="form-control"
              value={formData.pincode}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="gstin">GSTIN</label>
            <input
              type="text"
              id="gstin"
              name="gstin"
              className="form-control"
              value={formData.gstin}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-3">
            <label htmlFor="maintainBalance">Maintain Inventory</label>
            <Select
              id="maintainBalance"
              name="maintainBalance"
              options={booleanOptions} // uses same Yes/No options you already imported
              value={booleanOptions.find(option => option.value == formData.maintainBalance) || null}
              onChange={(option) =>
                setFormData((prev) => ({ ...prev, maintainBalance: option ? option.value : '' }))
              }
              placeholder="Select Yes or No"
              isDisabled={readOnly}
            />
          </div>

          <div className="col-md-9">
            <label htmlFor="printName">Print Ledger Name</label>
            <input
              type="text"
              id="printName"
              name="printName"
              className="form-control"
              value={formData.printName}
              onChange={handleInputChange}
              readOnly
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label htmlFor="person1">Contact Person 1</label>
            <input
              type="text"
              id="person1"
              name="person1"
              className="form-control"
              value={formData.person1}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="position1">Position (Person 1)</label>
            <input
              type="text"
              id="position1"
              name="position1"
              className="form-control"
              value={formData.position1}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="mobile1">Mobile (Person 1)</label>
            <input
              type="text"
              id="mobile1"
              name="mobile1"
              className="form-control"
              value={formData.mobile1}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label htmlFor="person2">Contact Person 2</label>
            <input
              type="text"
              id="person2"
              name="person2"
              className="form-control"
              value={formData.person2}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="position2">Position (Person 2)</label>
            <input
              type="text"
              id="position2"
              name="position2"
              className="form-control"
              value={formData.position2}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
          <div className="col-md-4">
            <label htmlFor="mobile2">Mobile (Person 2)</label>
            <input
              type="text"
              id="mobile2"
              name="mobile2"
              className="form-control"
              value={formData.mobile2}
              onChange={handleInputChange}
              readOnly={readOnly}
            />
          </div>
        </div>
        {!readOnly ? (
          <div className="text-end">
            <button type="submit" className="btn btn-success">
              {row ? 'Update' : 'Save'}
            </button>
          </div>
        ) : null}
      </form>
    </div>
  );
};

export default LedgerMaster;
